export {
  default as PasswordInput,
  type PasswordInputProps,
} from './PasswordInput';
